import { useState } from 'react'
import {
    DndContext,
    closestCenter,
    MouseSensor,
    TouchSensor,
    useSensor,
    useSensors,
} from '@dnd-kit/core'
import { arrayMove, SortableContext, rectSortingStrategy } from '@dnd-kit/sortable'
import { SortableImages } from './SortableImages'
import { LuxButton, LuxIcon } from '@lux/wardrobe-lib'
import './DragDrop.scss'
import { useIntl } from 'react-intl'

export const DragDrop = (props: {
    images: { id: string; url: string }[]
    onSetImages: (image: any) => void
    onAddImage: () => void
    onRemoveImage: (photoId: string) => void
}) => {
    const intl = useIntl()
    const { images, onSetImages, onAddImage, onRemoveImage } = props
    const [activeId, setActiveId] = useState(null)
    const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor))

    const handleDragStart = (event) => {
        setActiveId(event.active.id)
    }

    const handleDragEnd = (event) => {
        const { active, over } = event

        if (active.id !== over.id) {
            const oldIndex = images.findIndex((item) => item.id === active.id)
            const newIndex = images.findIndex((item) => item.id === over.id)

            const newImages = arrayMove(images, oldIndex, newIndex)

            onSetImages(newImages)
        }

        setActiveId(null)
    }

    const handleDragCancel = () => {
        setActiveId(null)
    }

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            onDragCancel={handleDragCancel}>
            <SortableContext items={images} strategy={rectSortingStrategy}>
                <div className="sortable-container">
                    {(() => {
                        const items = []
                        for (let i = 0; i < 7; i++) {
                            const item = images[i]
                            items.push(
                                <div key={i}>
                                    {item ? (
                                        <SortableImages
                                            id={item.id}
                                            url={item.url}
                                            index={i}
                                            activeId={activeId}
                                        />
                                    ) : (
                                        <div className="empty-img">
                                            <LuxIcon icon="picture-plus" size={45} />
                                            <LuxButton
                                                variant="text"
                                                onClick={onAddImage}
                                                text={intl.formatMessage({
                                                    id: 'ph2.gallery.add.photo',
                                                    defaultMessage: 'Add photo',
                                                })}
                                            />
                                        </div>
                                    )}
                                    <div className="flex justify-content-between align-items-center">
                                        <span>#{i + 1}</span>
                                        {item && images.length > 1 && (
                                            <LuxButton
                                                variant="text"
                                                onClick={onRemoveImage.bind(null, item.id)}
                                                text={intl.formatMessage({
                                                    id: 'ph2.modals.remove_user',
                                                    defaultMessage: 'Remove',
                                                })}
                                                style={{ padding: 0 }}
                                            />
                                        )}
                                    </div>
                                </div>
                            )
                        }
                        return items
                    })()}
                </div>
            </SortableContext>
        </DndContext>
    )
}
